<div id="startup-loader">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
